/*
  PendingPenalties,
  Active,
  Approved,
  Rejected,
  Expired,
  Cancelled
 */

// @ts-ignore
enum EscrowState {
  AWAITING_PENALTIES = "Pending penalties",
  ACTIVE = "Active",
  APPROVED = "Approved",
  CANCELED = "Cancelled",
}

const getFormattedStatus = (status: number) => {
  switch (status) {
    case 0:
      return {
        id: 0,
        state: EscrowState.AWAITING_PENALTIES,
        name: "Pending penalties",
        color: "badge-warning",
      };
    case 1:
      return {
        id: 1,
        state: EscrowState.ACTIVE,
        name: "Active",
        color: "badge-info",
      };
    case 2:
      return {
        id: 2,
        state: EscrowState.APPROVED,
        name: "Approved",
        color: "badge-success",
      };
    case 3:
      return {
        id: 3,
        state: EscrowState.CANCELED,
        name: "Rejected",
        color: "badge-error",
      };
    case 4:
      return {
        id: 4,
        state: EscrowState.CANCELED,
        name: "Expired",
        color: "badge-error",
      };
    case 5:
      return {
        id: 5,
        state: EscrowState.CANCELED,
        name: "Mutually cancelled",
        color: "badge-error",
      };
    default:
      return {
        id: -1,
        state: EscrowState.CANCELED,
        name: "Unknown",
        color: "badge-dark",
      };
  }
};

export { getFormattedStatus, EscrowState };
